<template>
  <div class="mainContainer">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: planType === 0 }">预报计划</div>
      <div @click="typeFun(1)" class="right" :class="{ active: planType === 1 }">预配计划</div>
    </div>
    <div class="nav">
      <div class="navContainer" v-show="planType==0" style="width: 230px">
        <p>起始港：</p>
        <el-input v-model="searchTerm.start" size="mini" style="width:150px" placeholder="请输入起始地"/>
      </div>
      <div class="navContainer" v-show="planType==0" style="width: 230px">
        <p>交车港：</p>
        <el-input v-model="searchTerm.delivery" size="mini" style="width:150px" placeholder="请输入交车地"/>
      </div>
      <div class="navContainer" v-show="planType==0" style="width: 230px">
        <p>品牌：</p>
        <el-input v-model="searchTerm.brand" size="mini" style="width:150px" placeholder="请输入品牌"/>
      </div>
      <div class="navContainer" v-show="planType==0" style="width: 230px">
        <p>型号：</p>
        <el-input v-model="searchTerm.model" size="mini" style="width:150px" placeholder="请输入型号"/>
      </div>
      <div class="navContainer" v-show="planType==1" style="width: 230px">
        <p>船舶名称：</p>
        <el-input v-model="searchTerm.ship" size="mini" style="width:150px" placeholder="请输入船舶"/>
      </div>
      <div class="navContainer" v-show="planType==1" style="width: 230px">
        <p>航次：</p>
        <el-input v-model="searchTerm.voyage" size="mini" style="width:150px" placeholder="请输入航次"/>
      </div>
      <div class="navContainer" v-show="planType==1" style="width: 230px">
        <p>编制人：</p>
        <el-input v-model="searchTerm.prepared" size="mini" style="width:150px" placeholder="请输入编制人"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>时间：</p>
        <el-date-picker
          v-model="searchTerm.date"
          style="width:150px"
          size="mini"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择日期"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" v-show="planType==0" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" v-show="planType==0" type="primary" :loading="loading" @click="generateBtn">生成预报计划</el-button>
      </div>
    </div>
    <div class="content">
      <div v-if="planType==0" class="tableContainer">
        <el-table
          :data="TableDatas"
          key="planTable"
          v-loading="tableLoad"
          style="width: 100%" border stripe
          @expand-change="expandChange"
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}">
          <el-table-column type="expand" width="30">
            <template slot-scope="scopeOut">
              <div style="width: 80%;margin-left: auto;" v-show="scopeOut.row.children.length>0">
                <el-table
                  v-show="scopeOut.row.children.length>0"
                  :data="scopeOut.row.children"
                  border
                  stripe
                  style="width: 100%"
                  :ref="scopeOut.row.id"
                  @selection-change="handleCurrentChange($event,scopeOut.$index)"
                  :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
                  :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
                >
                  <!-- <el-table-column label="序号" align="center" width="50px" type="index"/> -->
                  <el-table-column type="selection" align="center" width="50px"/>
                  <el-table-column prop="batch_number" label="批次号" align="center"/>
                  <el-table-column prop="plan_count" label="运输数量" align="center"/>
                  <el-table-column prop="surplus_count" label="剩余数量" align="center"/>
                  <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="innerScope">
                      <div style="align-items:center;padding-left: 10px">
                        <el-button size="mini" type="primary" @click="changeClick(innerScope.row)" class="yellow-bg">修改</el-button>
                        <el-button size="mini" type="danger" @click="deleteClick(innerScope.row)">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="startPortName" label="起始港" align="center"/>
          <el-table-column prop="endPortName" label="交车港" align="center"/>
          <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/>
          <el-table-column prop="planCount" label="运输数量" align="center"/>
          <el-table-column prop="surplusCount" label="剩余数量" align="center"/>
        </el-table>
      </div>
      <div v-else class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableData"
          style="width: 100%" border
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="shipName" label="船名" align="center"/>
          <el-table-column prop="voyageNumber" label="航次" align="center"/>
          <el-table-column prop="stowageNum" label="配置数量" align="center"/>
          <!-- <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/> -->
          <el-table-column prop="weight" label="重量(吨)" align="center"/>
          <el-table-column prop="reviewer" label="编制人" align="center"/>
          <el-table-column prop="createTime" label="预配时间" align="center"/>
          <el-table-column label="操作" align="center" min-width="200">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="printClick(scope.row)">打印</el-button>
                <el-button size="mini" v-if="scope.row.isDeleted==0" type="danger" @click="delClick(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="teamData" label-width="110px" :rules="rules" ref="ruleForm">
          <el-form-item label="批次号：" prop="batch">
            <el-input
              :style="'width:100%'"
              v-model="teamData.batch"
              placeholder="请输入批次号"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item v-if="type == 1" label="起始港口：" prop="start">
            <el-select filterable v-model="teamData.start" size="mini" style="width:100%;" placeholder="请选择起始港口名称" value-key="id">
              <el-option v-for="item in tempOption" :key="item.id" :label="item.supplier_name" :value="item"/>
            </el-select>
            <!-- <el-cascader v-model="teamData.start":options="tempOption":props="props"/> -->
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item v-if="type == 1" label="交车港口：" prop="delivery">
            <el-select filterable v-model="teamData.delivery" size="mini" style="width:100%;" placeholder="请选择交车港口名称" value-key="id">
              <el-option v-for="item in tempOption" :key="item.id" :label="item.supplier_name" :value="item"/>
            </el-select>
            <!-- <el-cascader v-model="teamData.delivery" :options="tempOption" :props="props"/> -->
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item v-if="type == 1" label="品牌/型号：" prop="model">
            <el-cascader
              size="mini"
              style="width:100%"
              v-model="teamData.model"
              :options="modelOption"
              filterable
              :props="{value:'id',label:'model',children:'carModel'}"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="委托数量：" prop="num">
            <el-input
              :style="'width:100%'"
              v-model="teamData.num"
              placeholder="请输入计划委托数量"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="loading" size="small" @click="addClick">确定</el-button>
            <el-button class="resetBtn" size="small" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="生成预配计划" :visible.sync="forecastVisible" width='600px' center @close="forecastClose" :close-on-click-modal="false">
      <div class="forecast">
        <el-form :model="forecast" label-width="110px" :rules="forecastRules" ref="forecastForm">
          <div-border label="基本信息" style="padding:20px 10px 10px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择船舶：" prop="ship">
                  <el-select filterable v-model="forecast.ship" size="mini" style="width:100%;" placeholder="请选择船舶" value-key="id">
                    <el-option v-for="item in shipOptions" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="编制人：" prop="brawUp">
                  <el-input style="width:100%" v-model="forecast.brawUp" placeholder="请输入编制人" size="mini"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核人：" prop="audit">
                  <el-input style="width:100%" v-model="forecast.audit" placeholder="请输入审核人" size="mini"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="预配计划" style="padding:20px 10px 0px">
            <div style="padding-bottom: 20px;" v-for="(item,index) in forecast.children" :key="index">
              <span>此单数量：{{item.num}}辆</span>
              <el-table :data="item.list" style="width: 100%" border
                :header-cell-style="{color:'#3B3B3B','font-size':'13px',background:'#E8E8E8'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px',}">
                <el-table-column prop="batch_number" label="批次号" min-width="130" align="center"/>
                <el-table-column prop="plan_counts" label="待配数量" align="center">
                  <template slot-scope="scope">
                    <el-input style="width:100%" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"  v-model="scope.row.plan_counts" @change="countChange(index)" placeholder="请输入待配数量" size="mini"/>
                  </template>
                </el-table-column>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <!-- <el-table-column prop="weight" label="重量(吨)" align="center"/> -->
                <el-table-column prop="start_port_name" label="起始港" align="center"/>
                <el-table-column prop="end_port_name" label="交车港" align="center"/>
                <el-table-column prop="mark" label="备注" align="center">
                  <template slot-scope="scope">
                    <el-input style="width:100%" v-model="scope.row.mark" placeholder="备注" size="mini"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <span v-if="forecast.children.length==1&&item.list.length==1">--</span>
                    <span v-else class="el-icon-circle-close" @click="delPlan(index,scope.$index)"></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="loading" size="small" @click="forecastClick">确定</el-button>
            <el-button class="resetBtn" size="small" @click="forecastClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='700px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>调配信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">船舶名称：</span>
                <span>{{detailData.shipName}}</span>
              </div>
              <div>
                <span class="span1">航次：</span>
                <span>{{detailData.voyageNumber}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">编制人：</span>
                <span>{{detailData.preparedPeople}}</span>
              </div>
              <div>
                <span class="span1">部门：</span>
                <span>{{detailData.deptName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">审核人：</span>
              <span>{{detailData.reviewer}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">计划时间：</span>
              <span>{{detailData.createTime}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>配置信息</span>
          </div>
          <div class="operationTable">
            <div style="padding-bottom: 20px;" v-for="(item,index) in detailData.children" :key="index">
              <span>此单数量：{{item.num}}辆</span>
              <el-table :data="item.list" style="width: 100%" border
                :header-cell-style="{color:'#3B3B3B','font-size':'13px',background:'#E8E8E8'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px',}">
                <el-table-column prop="batchNumber" label="批次号" min-width="130" align="center"/>
                <el-table-column prop="stowages" label="待配数量" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="weightsum" label="重量(吨)" align="center"/>
                <el-table-column prop="startPortName" label="起始港" align="center"/>
                <el-table-column prop="endPortName" label="交车港" align="center"/>
                <el-table-column prop="loadingReq" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="打印详情" :visible.sync="printVisible" width="1000px">
      <div id="printTest" v-html="PrintMessage"></div>
      <el-button class="print-btn" type="primary" size="mini" v-print="'#printTest'" >打印</el-button>
      <el-button class="print-btn" size="mini" @click="printVisible = false">取消</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { pageList, predictionAdd,predictionDelete,
predictionUpdate,getCarSerieList,supplierPublicSelectPort,
provisioningDetail,predictionPlanAdd,selectAllShip,
provisionPageList,provisionDelete,provisioningPrint1} from '@/service/vehiclelog'
import { brandGetCarBrandList, } from "@/service/basicfile"
import divBorder from '@/components/divBorder'
import {getSessionStore} from '@/config/mUtils'
import {getImport} from "@/service/getIP"

export default {
  components: { divBorder },
  data() {
    let validateNum=function (rule, value, callback) {
      if (Number(value) <0){
        callback(new Error('计划托运数量必须大于0'));
      }
      callback();

    }
    let date = new Date();
    let month = date.getMonth()+1;
    let day = date.getDate();
    if (month < 10) { month = "0" + month; }
    if (day < 10) { day = "0" + day; }
    let nowDate = date.getFullYear() + "-" + month + "-" + day;
    return {
      planType: 0,   // 菜单切换
      // 查询条件
      searchTerm: {
        start: '',      //  起始地
        delivery:'',    // 交车地
        brand:'',       // 品牌
        model:'',       // 型号
        date: nowDate,  // 时间
        ship: '',   // 船舶名
        voyage: '',   // 航次
        prepared: '',   // 编制人
      },
      brandOption:[], // 品牌
      brandMap:new Map(),//保存品牌型号id，名称
      modelOption:[], // 型号
      modelMap:new Map(),//保存品牌型号id，名称
      // 起始地/交车地
      tempOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      TableData:[],

      // 详情
      detailDialogVisible: false,
      detailData: {},
      // 打印
      printVisible: false,
      PrintMessage:'',

      // 新增/修改
      dialogTitle:'',
      dialogVisible:false,
      loading:false,
      // 新增/修改弹窗数据
      type: 1, // 1:新增弹窗   2:修改弹窗
      teamData:{
        batch: '',    // 批次号
        start:'',       // 起始地
        delivery:'',    // 交车地
        brand:'',       // 品牌
        // model:'',       // 型号
        num:'',         // 数量
      },
      rules:{
        batch:[
          { required: true, message: '请输入批次号', trigger: 'blur' },
        ],
        start:[
          { required: true, message: '请选择起始地', trigger: 'blur' },
        ],
        delivery:[
          { required: true, message: '请选择交车地', trigger: 'blur' },
        ],
        // brand:[
        //   { required: true, message: '请选择品牌', trigger: 'blur' },
        // ],
        model:[
          { required: true, message: '请选择品牌/型号', trigger: 'blur' },
        ],
        num:[
          { required: true, message: '请输入计划委托数量', trigger: 'blur' },
          { validator: validateNum, trigger: 'blur' }
        ],
      },
      selectData: [],  // 已选择数据
      forecastVisible: false,   // 生成预报计划弹窗显隐
      shipOptions: [],  // 选择船舶
      forecast: {  // 生成预报计划数据
        ship:'',
        brawUp:'',
        audit:'',
        children: [{num:'',list:[]}],
      },
      forecastRules: {
        ship: { required: true, message: '请选择船舶', trigger: 'blur' },
        brawUp: { required: true, message: '请输入编制人', trigger: 'blur' },
        audit: { required: true, message: '请输入审核人', trigger: 'blur' },
      },
    };
  },
  computed:{
  },
  async mounted() {

    await this._brandGetCarBrandList();
    await this._modelData();
    await this._selectAllShip();
    this.tempOption = JSON.parse(sessionStorage.getItem('areaList'));
  },
  methods: {
    // 预报计划 —— 分页查询
    async _pageList(){
      this.tableLoad = true;
      const obj={
        startPortName: this.searchTerm.start, //  起始地
        endPortName: this.searchTerm.delivery, // 交车地
        brand: this.searchTerm.brand, // 品牌
        model: this.searchTerm.model, // 型号
        selectTime: this.searchTerm.date || '', // 时间
        rows:this.size,
        page:this.page,
      };
      const res = await pageList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      if(res.data.records.length>0){
        res.data.records.forEach((item,index) => {
          item.index = index;
          if(item.children.length > 0){
            item.children.forEach(tem => {
              tem.plan_counts = parseInt(tem.surplus_count);
            })
          }
        })
      }
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    // 预配计划 —— 分页查询
    async _provisionPageList(){
      this.tableLoad = true;
      const obj={
        shipName: this.searchTerm.ship, //  船舶名
        voyageNumber: this.searchTerm.voyage, // 航次
        preparedPeople: this.searchTerm.prepared, // 编制人
        selTime: this.searchTerm.date || '', // 时间
        rows:this.size,
        page:this.page,
      };
      const res = await provisionPageList(obj);
      if(res.status !== 0) return this.$message.error(res.message);
      this.tableLoad=false;
      this.TableData = res.data.records;
      this.total = res.data.total;
    },
    // 预报计划/预配计划 —— 切换
    typeFun(val) {
      this.resetBtn();
      this.planType = val;
      this.TableDatas=[];
      this.selectData = [];
      this.page = 1;
      // if(this.planType == 0){
      //   this._pageList();
      // }else {
      //   this._provisionPageList();
      // }
    },
    // 获取港口
    async _getPortList() {
      const res = await supplierPublicSelectPort();
      if(res.status !== 0) this.$message.error(res.message);
      else this.tempOption=res.data;
    },
    tableRowClassName({row}) {
      if (row.state) return 'ui-warning-row';
      else return '';
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._pageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._pageList();
    },
    // 获取品牌
    async _brandGetCarBrandList(){
      let res =await brandGetCarBrandList()
      if (res.status !==0)  return  this.$message.error(res.message)
      this.brandOption = res.data;
    },
    // 获取型号
    async _modelData(){
      const res5 = await getCarSerieList();
      if(res5.status !== 0) this.$message.error(res5.message);
      else this.modelOption=res5.data.map(item=>{
        //保存品牌id 名称
        this.brandMap.set(item.id,item.brand)
        item.carModel.forEach(carItem=>{
          // 保存型号id 名称
          this.modelMap.set(carItem.id,carItem.model)
        })
        return{
          ...item,
          model:item.brand
        }
      })
    },
    // 获取船舶
    async _selectAllShip(){
      let res = await selectAllShip();
      if (res.status !==0) return this.$message.error(res.message);
      this.shipOptions = res.data;
    },

    // 展开行
    expandChange(row,val){
      const isExpend = val.some(r => r.index === row.index);
      if(isExpend&&val.length>0){
        if(this.selectData.length > 0){
          let flg = false;
          this.selectData.forEach(item => {
            if(item.id == row.startPortId+row.endPortId+row.brandId+row.modelId) {
              if(item.list.length > 0){
                item.list.forEach(tem => {
                  this.$nextTick(() => {
                    console.log(this.$refs[row.id]);
                    this.$refs[row.id].toggleRowSelection(
                    row.children.find(tem1 => { return tem.id == tem1.id;})
                    ,true);
                  })
                })
              }
              return flg = true
            }
          })
          if(!flg) this.selectData.push({id:row.startPortId+row.endPortId+row.brandId+row.modelId,list:[]});
        }else{
          this.selectData.push({id:row.startPortId+row.endPortId+row.brandId+row.modelId,list:[]});
        }
      }
    },
    // 多选框选择
    handleCurrentChange(val,index){
      if(val.length>0&&val[0]){
        this.selectData.filter(item => {
          if(item.id == val[0].start_port_id+val[0].end_port_id+val[0].brand_id+val[0].model_id){
            item.list = val;
          }
        })
      }
    },
    // 根据属性分割对象数组
    groupingData(data, filed){
      // map用来保存存过的字段 为下边添加新对象或者将相同字段的数据保存到同一个list中
      let map = {};
      // dest主要保存分组后的数据
      let dest = [];
      // 循环遍历传入的data
      data.forEach(item => {
      // 判断map对象中是否有遍历时data的key 如果没有则向dest数组中推入一个新的对象(包含两个属性，一个要分组的字段名，一个保存相同字段名数据的数组)
        if(!map[item[filed]]) {
          dest.push({
            [filed]: item[filed],
            list: [item]
          });
          // 进行一次新添对象的记录
          map[item[filed]] = item;
          // 如果在map中有data遍历的key(字段相同) 则向dest数组里面的相同字段的list下推入数据
        } else {
          dest.forEach(dItem => {
            if (dItem[filed] == item[filed]) {
              dItem.list.push(item);
            }
          });
        }
      })
      return dest;
    },
    // 对象数组指定属性值求和
    countTotal(arr, keyName){
        let $total = 0;
        $total = arr.reduce((total, currentValue) => {
          return currentValue[keyName] ? (total + parseInt(currentValue[keyName])) : total;
        }, 0);
        return $total;
    },
    // 生成预报计划 —— 待配数量改变
    countChange(index){
      this.forecast.children[index].num = this.countTotal(this.forecast.children[index].list,'plan_counts');
    },
    // 生成预报计划 —— 按钮
    generateBtn(){
      if(this.selectData.length <= 0) return this.$message.error('请选择至少一条数据！');
      this.loading = true;
      this.forecast = {
        ship:'',
        brawUp: getSessionStore('userName')||'',
        audit:'',
        children: [],
      };
      let lists = [];
      this.selectData.forEach(item => { lists = lists.concat( item.list ); })
      let tempList = this.groupingData(lists,'start_port_id');
      if(tempList.length > 0){
        tempList.forEach(item => {
          this.forecast.children.push({
            num: this.countTotal(item.list,'plan_counts'),
            list: item.list
          })
        })
      }
      this.forecastVisible = true;
      this.loading = false;
    },
    // 生成预报计划 —— 确认
    forecastClick(){
      this.$refs.forecastForm.validate(async (valid) => {
        if (valid) {
          let temp = [];
          if(this.forecast.children.length > 0){
            this.forecast.children.forEach(item => {
              if(item.list.length>0) temp = temp.concat(item.list);
            })
          }
          if(temp.length == 0) return this.$message.error('至少有一条预配计划！');
          let arr = [];
          temp.forEach(item => {
            arr.push({
              id: item.id,
              planCount: item.plan_counts,
              loadingReq: item.mark || ''
            })
          })
          let obj = {
            shipId: this.forecast.ship.id,
            shipName: this.forecast.ship.name,
            preparedPeople: this.forecast.brawUp,
            reviewer: this.forecast.audit,
            transportPredictionLists: arr,
          };
          // return false
          this.loading = true;
          const res = await predictionPlanAdd(obj);
          this.loading = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          this.forecastClose();
          await this._pageList();
        } else {
          return false;
        }
      });
    },
    // 生成预报计划 —— 取消
    forecastClose(){
      this.forecast = {
        ship: '',
        brawUp: '',
        audit: '',
        children: [{num:'',list:[]}],
      };
      this.$refs.forecastForm.resetFields();
      this.forecastVisible = false;
    },
    // 生成预报计划 —— 删除预配计划
    delPlan(index1,index2){
      console.log(index1,index2,this.forecast.children[index1].list);
      if(this.forecast.children[index1]&&this.forecast.children[index1].list.length>index2){
        this.forecast.children[index1].list.splice(index2, 1);
      }
      if(this.forecast.children[index1].list.length>0){
        this.forecast.children[index1].num = this.forecast.children[index1].list.length;
      }else {
        this.forecast.children.splice(index1, 1);
      }
    },

    // 预配计划 —— 详情
    async detailClick(id){
      let res = await provisioningDetail({'id': id});
      if(res.status !== 0) return this.$message.error(res.message);
      let dept = JSON.parse(getSessionStore('userDept'));
      this.detailData = {
        shipName: res.data.shipName,
        voyageNumber: res.data.voyageNumber,
        preparedPeople: res.data.preparedPeople,
        reviewer: res.data.reviewer,
        createTime: res.data.createTime,
        deptName: (dept&&dept.length>0)?dept[0].depNm:'',
        children: [],
      }
      if(res.data.stringListMap){
        for(let keys in res.data.stringListMap) {
          this.detailData.children.push({
            num: this.countTotal(res.data.stringListMap[keys],'stowages'),
            list: res.data.stringListMap[keys],
          });
        }
      }
      this.detailDialogVisible = true;
    },
    // 预配计划 —— 打印
    async printClick(row){
      const res = await provisioningPrint1({'id': row.id});
      if(res.status !== 0) return this.$message.error(res.message);
      let url = getImport('/platform/print/printHtml');
      this.$axios({
        method: 'get',
        url: url,
        headers: {"content-type":"multipart/form-data"}
      }).then(res => {
        this.printVisible = true;
        this.PrintMessage = res.data;
      }).catch(error => {
        console.log(error);
      });
    },
    // 预配计划 —— 删除
    delClick(row){
      this.$confirm('确定删除该预配计划吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await provisionDelete({'id': row.id});
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._provisionPageList();
      }).catch(() => {});
    },
    // 修改弹窗
    changeClick(item){
      this.teamData={
        ...item,
        num: item.plan_count,
        batch: item.batch_number
      };
      this.type = 2;
      console.log(this.teamData);
      this.dialogTitle = '修改预报计划';
      this._getPortList();
      this.dialogVisible = true;
    },
    // 删除
    deleteClick(row){
      this.$confirm('确定要删除当前数据吗？', '提示', {
      confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await predictionDelete(row.id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._pageList();
      }).catch(() => {});
    },
    // 查询
    searchBtn(){
      this.page = 1;
      if(this.planType == 0){
        this._pageList();
      }else {
        this._provisionPageList();
      }
    },
    // 重置
    resetBtn(){
      let date = new Date();
      let month = date.getMonth()+1;
      let day = date.getDate();
      if (month < 10) { month = "0" + month; }
      if (day < 10) { day = "0" + day; }
      let nowDate = date.getFullYear() + "-" + month + "-" + day;
      this.searchTerm = {start:"",delivery:"",brand:"",model:"",date:nowDate,ship:'',voyage:'',prepared:''}
    },
    // 新增
    addBtn(){
      this.dialogTitle='添加预报计划';
      this.type = 1;
      this._getPortList();
      this.dialogVisible = true;
    },
    // 新增/修改确认
    addClick(){
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          console.log(this.teamData);
          this.loading = true;
          let obj = {};
          let change = {};
          if(this.type == 1) {
            // const start = this.$refs['startPosition'].getCheckedNodes();
            // const end = this.$refs['endPosition'].getCheckedNodes();
            obj = {
              // startAreaId: this.teamData.start.join(','),
              // startAreaName: start[0].pathLabels.join('/'),
              // endAreaId: this.teamData.delivery.join(','),
              // endAreaName: end[0].pathLabels.join('/'),
              // brand: this.brandMap.get(this.teamData.model[0]) || '',
              // brandId: this.teamData.model[0] || '',
              // model:this.modelMap.get(this.teamData.model[1]) || '',
              batchNumber: this.teamData.batch,
              startPortId: this.teamData.start.id,
              endPortId: this.teamData.delivery.id,
              modelId: this.teamData.model[1] || '',
              planCount: this.teamData.num,
            };
          }else {
            change = { id: this.teamData.id, batchNumber: this.teamData.batch, planCount: this.teamData.num }
          }
          const res = this.type == 1?await predictionAdd(obj):await predictionUpdate(change);
          this.loading = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          this.dialogVisible = false;
          await this._pageList();
        } else {
          return false;
        }
      });
    },
    // 关闭新增/修改弹窗
    dialogClose(){
      this.dialogVisible=false;
      this.teamData={ batch:'', start:'', delivery:'', num:'', model:'' };
      this.$refs.ruleForm.resetFields();
    },

    //
    bindRowKeys(row){
      return row.endPortId
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 240px;
    margin-bottom: 10px;
    div {
      //background: #ccc;
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599E;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599E;
      font-weight: 700;
      transition: all .3s;
    }
    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .right {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .active {
      background: #48599E;
      color: #fff;
    }
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:70vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
      .operationTable span {
        display: inline-block;
        width: 100%;
        padding-right: 20px;
        padding-bottom: 5px;
        font-size: 13px;
        text-align: right;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px 10px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .forecast {
    width:100%;
    padding: 30px 20px 20px;
    span {
      display: inline-block;
      width: 100%;
      padding-right: 20px;
      padding-bottom: 5px;
      font-size: 13px;
      text-align: right;
    }
    ::v-deep {
      .el-table td, .el-table th {
        padding: 5px 0px;
      }
      .el-table .cell span {
        font-size: 18px;
        height: 23px;
        line-height: 25px;
        padding: 0px;
        text-align: center;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-date-editor.el-input.el-input--mini.el-input--prefix.el-input--suffix.el-date-editor--date span.el-input__suffix span.el-input__suffix-inner i.el-input__icon {
    display: none;
  }
  .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }
  .el-table .ui-warning-row {
    background-color: #fef0f0!important;
  }
  .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
    background-color: #fef0f0!important;
  }
  .el-table .ui-warning-row .cell{
    color: red;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
  // td.el-table_1_column_1.undefined.el-table__expand-column,
  // th.el-table_1_column_1.undefined.el-table__expand-column.is-leaf {
  //   border-right: none !important;
  // }
}
#printTest {
  padding: 0px 0px 20px;
}
.print-btn {
  position: relative;
  left: calc(100% - 166px);
  margin-bottom: 20px;
}
</style>
